import { render, staticRenderFns } from "./ClassesEdit.vue?vue&type=template&id=2c23e600&scoped=true"
import script from "./ClassesEdit.vue?vue&type=script&lang=js"
export * from "./ClassesEdit.vue?vue&type=script&lang=js"
import style0 from "./ClassesEdit.vue?vue&type=style&index=0&id=2c23e600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23e600",
  null
  
)

export default component.exports